import { TextInputProps } from '@infotech-soe/erp-ui-kit';
import React from 'react';

import { DictionaryInputFormControlViewModel } from '../../../services/form/view-model/FormControlViewModel';
import LookupBox from '../LookupBox';

import { TFormControlConnectorProps } from './FormControlContainer';
import FormLabeledInputControl from './FormLabeledInputControl';
import FormTextControl from './hoc/FormTextControl';
import { RequiredHistoryProps, withHistory } from './hoc/HistoryContainer';
import { useDictionaryControl } from './useDictionaryControl';

type Props = TFormControlConnectorProps &
  Partial<RequiredHistoryProps<HTMLInputElement>> &
  Pick<TextInputProps, 'className' | 'keymap' | 'onValidate' | 'value'> & {
    control: DictionaryInputFormControlViewModel;
  };

const FormDictInputControl = (props: Props) => {
  const {
    areHintsShown,
    className,
    control,
    keymap,
    onRef,
    rounded,
    value,
    onChange,
    onChanged,
    onRunSingleUpdater,
    onSubmit,
    onValidate,
  } = props;
  const onButtonClick = useDictionaryControl(props);

  return (
    <FormLabeledInputControl areHintsShown={areHintsShown} control={control}>
      <LookupBox
        allowTextOverflow
        canClearOnReadOnly={control.canClearOnReadOnly}
        className={className}
        containerRef={onRef}
        disabled={control.disabled}
        invalid={control.invalid}
        keymap={keymap}
        lengthInBytes={control.lengthInBytes}
        maxLength={control.maxLength}
        name={control.name}
        readOnly={control.readonly}
        ref={onRef}
        required={control.required}
        rounded={rounded}
        value={value}
        onButtonClick={onButtonClick}
        onChange={onChange}
        onChanged={onChanged}
        onRunSingleUpdater={control.updater ? onRunSingleUpdater : undefined}
        onSubmit={onSubmit}
        onValidate={onValidate}
      />
    </FormLabeledInputControl>
  );
};

export default withHistory(FormTextControl(FormDictInputControl));
